import { AfterViewInit, Component, ElementRef, EventEmitter, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Camera, CameraResultType } from '@capacitor/camera';

@Component({
  selector: 'app-camera-component',
  templateUrl: './camera-component.component.html',
  styleUrls: ['./camera-component.component.scss']
})
export class CameraComponentComponent implements OnInit, AfterViewInit, OnDestroy {

  WIDTH = 640;
  HEIGHT = 480;

  @ViewChild("video")
  public video: ElementRef;

  @ViewChild("canvas")
  public canvas: ElementRef;

  @Output() photoTaken: EventEmitter<any> = new EventEmitter();

  captures: string[] = [];
  error: any;
  isCaptured: boolean;
  cameraLoaded = false;
  async ngAfterViewInit() {
    await this.setupDevices();
  }
  constructor() { }

  ngOnDestroy(): void {
    this.video.nativeElement.stop();
    this.cameraLoaded = false;
  }

  ngOnInit(): void {
  }

  async setupDevices() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });

        if (stream) {
          this.cameraLoaded = true;
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
          this.error = null;
        } else {
          this.error = "You have no output video device";
        }
      } catch (e) {
        this.error = e;
      }

    }
  }

  capture() {
    this.isCaptured = true;
    this.drawImageToCanvas(this.video.nativeElement);
    this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));
    this.video.nativeElement.pause();
    this.photoTaken.emit(this.canvas.nativeElement.toDataURL("image/png"));
  }
  retake() {
    this.video.nativeElement.play();
    this.isCaptured = false;
  }

  drawImageToCanvas(image: any) {
    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }
}
